import { getAgsApiUrl, smb_fetch } from '@/api/operator/fetch';


export const initTcccLogin = () => {
  const url = getAgsApiUrl('', 'call-center/sdk-login-tccc');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    {
      data: {
        path: 'call-center/sdk-login-tccc',
      },
    },
  );
  return smb_fetch(url, params, false, false);
};
